<template>
  <create-contact-card
    v-if="newContactRole"
    @close="close"
    :initialRole="newContactRole"
  />
  <div id="spin-contacts-gallery-wrapper">
    <base-card
      v-for="(arr, key, index) in contacts"
      :heading="key"
      :key="index"
      :icons="['plus']"
      :scrollable="!displayArt(arr)"
      @icon-clicked="iconClicked(key)"
      class="spin-contacts-gallery-item"
    >
      <img v-if="displayArt(arr)" :src="notFoundArt" alt="No contacts found" />
      <contact-list-item
        v-for="contact in arr"
        :key="contact.userId"
        :contact="contact"
        :deletable="false"
        @click="navigate(key, contact)"
      />
    </base-card>
  </div>
</template>
<script>
import BaseCard from "../Components/UI/BaseCard.vue";
import CreateContactCard from "../Components/UI/FloatingCards/CreateContactCard.vue";
import ContactListItem from "../Components/UI/ListItems/Contact/Standard.vue";

export default {
  data() {
    return {
      newContactRole: undefined,
      notFoundArt: require("../Components/UI/Illustrations/DesertNoContactsFound.png"),
    };
  },
  computed: {
    contacts() {
      return {
        Clients: this.$store.getters.clients(),
        Employees: this.$store.getters.employees(),
        Organizers: this.$store.getters.organizers(),
        Vendors: this.$store.getters.vendors(),
      };
    },
  },
  methods: {
    displayArt(category) {
      return !this.$store.getters.contactsRetrieved && category.length === 0;
    },
    iconClicked(key) {
      this.newContactRole = key.replace("s", "").toLowerCase();
    },
    close() {
      this.newContactRole = undefined;
    },
    navigate(role, contact) {
      this.$store.commit("setContact", contact);
      this.$router.push({
        name: "contact",
        params: {
          userId: contact.userId,
          role: role.toLowerCase(),
        },
      });
    },
  },
  mounted() {
    console.log(this.$store.getters.contacts);
  },
  components: {
    BaseCard,
    ContactListItem,
    CreateContactCard,
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #spin-contacts-gallery-wrapper {
    max-height: 750px;
    width: 100%;
    height: 100%;
    overflow-x: scroll;
    display: flex;
    scroll-snap-type: x mandatory;
  }

  .spin-contacts-gallery-item {
    overflow: scroll;
    scroll-snap-align: start;
    width: 100%;
    height: 80vh;
    margin: 0 10px;
    min-width: 100%;
  }

  img {
    width: 80%;
    height: 100%;
    object-fit: contain;
  }

  @media (min-width: 800px) {
    #spin-contacts-gallery-wrapper {
      max-height: unset;
      width: calc(100% + 100px);
      overflow-x: scroll;
      display: flex;
      scroll-snap-type: x mandatory;
    }

    .spin-contacts-gallery-item {
      scroll-snap-align: start;
      width: 65%;
      max-height: 100%;
      /* height: calc(100% - 5px); */
      min-width: 650px;
    }

    img {
      width: 80%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
